module.exports = __webpack_public_path__ + "static/media/copy.520b2347.svg";